/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TaskAttachment } from './TaskAttachment';
import type { TaskComment } from './TaskComment';
export type Task = {
    id: string;
    user_id: string;
    project_id?: string;
    title: string;
    description?: string;
    status: Task.status;
    due_date: string;
    is_key_event?: boolean;
    created_at?: string;
    updated_at?: string;
    assignees?: Array<string>;
    reviewers?: Array<string>;
    comments?: Array<TaskComment>;
    attachments?: Array<TaskAttachment>;
};
export namespace Task {
    export enum status {
        PLANNED = 'planned',
        IN_PROGRESS = 'in-progress',
        REVIEW = 'review',
        DONE = 'done',
    }
}

